import { TreeItem as KendoTreeItem } from '@progress/kendo-angular-treeview';
import { TreeItemDragEvent as KendoTreeItemDragEvent } from '@progress/kendo-angular-treeview';
import { TreeItemDropEvent as KendoTreeItemDropEvent } from '@progress/kendo-angular-treeview';
import { TreeItemDragStartEvent as KendoTreeItemStartDragEvent } from '@progress/kendo-angular-treeview';
import { Retype } from '@ups/xplat/utils';

export type TreeItem<T = unknown> = Retype<KendoTreeItem, 'dataItem', T>;
export type TreeItemLookup<T = unknown> = {
  children?: TreeItemLookup<T>[];
  item: TreeItem<T>;
  parent?: ItemLookup<T>;
};
export type ItemLookup<T = unknown> = Omit<TreeItemLookup<T>, 'children'> & {
  children: ItemLookup<T>[];
};
export type TreeItemDragEvent<T = unknown> = {
  destinationItem: TreeItemLookup<T>;
  originalEvent: KendoTreeItemDragEvent['originalEvent'];
  sourceItem: TreeItemLookup<T>;
};
export type TreeItemDragStartEvent<T = unknown> = Retype<
  KendoTreeItemStartDragEvent,
  'sourceItem',
  TreeItemLookup<T>
>;
export type TreeItemDropEvent<T = unknown> = Omit<
  KendoTreeItemDropEvent,
  'destinationItem' | 'sourceItem'
> & {
  destinationItem: TreeItemLookup<T>;
  sourceItem: TreeItemLookup<T>;
};
